/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { AB } from "./constants";

export function DPIScaleToValue(scale: number): string {
   return (scale * AB.DPI_100_PERCENT).toString();
}

class UtilFunction {
   private chromeClient: boolean = false;

   constructor() {
      try {
         // Edge has chrome, but doesn't has chrome.management
         this.chromeClient = !!chrome && !!chrome.management;
      } catch (e) {
         // Safari/Firefox/IE is throwing error here
      }
   }

   public isChromeClient() {
      return this.chromeClient;
   }
}

export const core = new UtilFunction();
